module.exports = __webpack_public_path__ + "img/nodata-img1.d4feb829.png";